import React, { Component } from 'react'

export default class LoadHtml extends Component {

    constructor(props) {
        super(props)
        this.state = {
            content: null
        }
    }

    componentWillMount() {
        fetch(this.props.file)
        .then(response => response.text())
        .then(resp => {
          this.setState({
              content: resp
          })
        })
        .catch(() => {
            console.log('Error')
        })

        
    }

    render() {
        if(!this.state.content) {
            if(this.props.loading)
                return (<div>{this.props.loading}</div>)
            
            return null
        } 

        return (
            <div
                {...this.props}
                dangerouslySetInnerHTML={{__html: this.state.content}}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/LoadHtml/index.js